import { validations } from "../../../../../config/validations/validations";
import {
  maxCode,
  minCode,
  minName,
  maxName,
} from "../../../../../config/Validators";

export const rules: any = {
  name: () => [
    validations.required.text(),
    validations.min.text(minName),
    validations.max.text(maxName),
  ],
  code: () => [
    validations.required.text(),
    validations.min.text(minCode),
    validations.max.text(maxCode),
  ],
};
